export default (props = {}) => <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M9 1.16766L5.66766 4.5L9 7.83234L7.83234 9L4.5 5.66766L1.16766 9L0 7.83234L3.33234 4.5L0 1.16766L1.16766 0L4.5 3.33234L7.83234 0L9 1.16766Z" fill="currentColor"/>
</svg>
